import { mockBuilder } from '../../utils/builderHelper.es.js';
import { DiscountTypeEnum } from '../../enums/billing/DiscountTypeEnum.es.js';
import { InvoicePreviewDetail, InvoicePreviewDiscount, InvoicePreview } from './InvoicePreview.es.js';

/** @module Mocks */ /** typedoc */
// Section: InvoicePreviewDetail
function anInvoicePreviewDetail() {
    return mockBuilder(new InvoicePreviewDetail())
        .withQuantity(5)
        .withUnitPrice(5)
        .withUnitPriceUSD(5)
        .withUnitPriceCAD(10)
        .withAmount(25)
        .withAmountUSD(25)
        .withAmountCAD(50)
        .withDiscount(5)
        .withDiscountUSD(5)
        .withDiscountCAD(10)
        .withDiscountPercent(20)
        .withSubTotalAmount(20)
        .withSubTotalAmountUSD(20)
        .withSubTotalAmountCAD(40)
        .withDiscountPercent(20)
        .withName('product')
        .withCurrencyCode('USD')
        .withCurrencySymbol('$');
}
function aFreeInvoicePreviewDetail() {
    return mockBuilder(new InvoicePreviewDetail())
        .withQuantity(1)
        .withUnitPrice(0)
        .withUnitPriceUSD(0)
        .withUnitPriceCAD(0)
        .withAmount(0)
        .withAmountUSD(0)
        .withAmountCAD(0)
        .withDiscount(0)
        .withDiscountUSD(0)
        .withDiscountCAD(0)
        .withDiscountPercent(20)
        .withSubTotalAmount(0)
        .withSubTotalAmountUSD(0)
        .withSubTotalAmountCAD(0)
        .withName('free-product')
        .withCurrencyCode('USD')
        .withCurrencySymbol('$');
}
// Section: InvoicePreviewDiscount
function anInvoicePreviewDiscount() {
    return mockBuilder(new InvoicePreviewDiscount())
        .withAmount(4)
        .withValue(50)
        .withType(DiscountTypeEnum.Percentage)
        .withCurrencyCode('USD')
        .withCurrencySymbol('$');
}
// Section: InvoicePreview
function anInvoicePreview() {
    return mockBuilder(new InvoicePreview())
        .withTotalAmount(24)
        .withTotalAmountUSD(24)
        .withTotalAmountCAD(48)
        .withBaseAmount(25)
        .withBaseAmountUSD(25)
        .withBaseAmountCAD(50)
        .withSubTotalAmount(20)
        .withSubTotalAmountUSD(20)
        .withSubTotalAmountCAD(40)
        .withTaxAmount(4)
        .withTaxAmountUSD(4)
        .withTaxAmountCAD(8)
        .withTotalDiscount(5)
        .withTotalDiscountUSD(5)
        .withTotalDiscountCAD(10)
        .withDiscountPercent(20)
        .withDueAmount(14)
        .withDiscounts([anInvoicePreviewDiscount()])
        .withCredit(10)
        .withCurrencyCode('USD')
        .withCurrencySymbol('$')
        .withDetails([aFreeInvoicePreviewDetail(), anInvoicePreviewDetail()])
        .withQuantity(3)
        .withIsTaxComputationSkipped(false);
}
function aFreeInvoicePreview() {
    return mockBuilder(new InvoicePreview())
        .withTotalAmount(0)
        .withBaseAmount(0)
        .withSubTotalAmount(0)
        .withTaxAmount(0)
        .withTotalDiscount(0)
        .withTotalAmountUSD(0)
        .withBaseAmountUSD(0)
        .withSubTotalAmountUSD(0)
        .withTaxAmountUSD(0)
        .withDiscounts([])
        .withCredit(0)
        .withCurrencyCode('USD')
        .withCurrencySymbol('$')
        .withDetails([aFreeInvoicePreviewDetail().withQuantity(3)])
        .withQuantity(3);
}

export { aFreeInvoicePreview, aFreeInvoicePreviewDetail, anInvoicePreview, anInvoicePreviewDetail, anInvoicePreviewDiscount };
